import script from "./Price.vue?vue&type=script&setup=true&lang=ts"
export * from "./Price.vue?vue&type=script&setup=true&lang=ts"

import "./Price.vue?vue&type=style&index=0&id=10ade15c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ade15c"]])

export default __exports__